// App URL passthrough login (UNB Asana 1217196196610358). The event app sends
// attendees to e.g. /activities?ticketID=xyz&token=<sha256(email)>; if the
// hash matches the ticket's registered email on Bizzabo, the visitor is logged
// in without touching the login form. The server route does all verification —
// this middleware just forwards the params and strips them from the URL
// afterwards (success or not) so the credential never lingers somewhere
// shareable like a copied link.
export default defineNuxtRouteMiddleware(async (to) => {
    if (import.meta.server) return;

    // Spec-cased `ticketID`, but accept the obvious variants.
    const ticketId = to.query.ticketID || to.query.ticketId || to.query.ticketid;
    const token = to.query.token;
    if (!ticketId || !token) return;

    const { loggedIn, fetch: refreshSession } = useUserSession();

    // Already signed in — don't replace the session, just clean the URL.
    if (!loggedIn.value) {
        try {
            await $fetch('/api/v1/user/passthrough', { method: 'POST', body: { ticketId, token } });
            await refreshSession();
        } catch {
            // Verification failed — land on the page logged out; the normal
            // login modal is still available.
        }
    }

    const { ticketID: _a, ticketId: _b, ticketid: _c, token: _d, ...query } = to.query;
    return navigateTo({ path: to.path, query, hash: to.hash }, { replace: true });
});
